import { Theme } from '@melements/front-components';
import closeIcon from 'assets/icons/close.svg';
import failIcon from 'assets/icons/icon-error.svg';
import successIcon from 'assets/icons/icon-success.svg';

const icons = {
  ...Theme.variables.icons,
  svg: {
    ...Theme.variables.icons.svg,
    closeIcon,
    failIcon,
    successIcon,
  },
};

const layout = {
  column: {
    count: 12,
    gap: '1.5rem',
    width: '5.4375rem',
  },
};

const customColors = {
  ...Theme.variables.customColors,
  backgroundColor: '#F6F8F9',
  boxBorder: '#d4d4d4',
  boxShadow: '0 0 0.5625rem 0 rgba(0, 0, 0, 0.08), 0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.22)',
  grayMedium: '#6a6a72',
  green: '#16a035',
  inputPlaceholder: '#626262',
  leadingColor: {
    base: '#142897',
    dark: '#201C17',
    mid: '#2B4F69',
  },
  lightBlue: '#53a9d3',
  lightGrey: '#fafafa',
  lightGreyText: '#979797',
  lightNavy: '#0088ca',
  linkColor: '#e41e0a',
  navy: '#60b0d6',
  sidebarBackgroundColor: '#F0F2F3',
  stripColors: {
    stripColor1: '#e41e0a',
    stripColor2: '#201c17',
    stripColor3: '#f39100',
    stripColor4: '#cc0b18',
    stripColor5: '#0077bd',
    stripColor6: '#18a035',
  },
  superLightGrey: '#ececec',
  textColor: '#36363b',
};

export const variables = {
  ...Theme.variables,
  customColors,
  icons,
  layout,
};
